import { AfterViewInit, Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { forEach } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { config } from 'process';
import { Screening, ScreeningAdditionalData, ScreeningNote } from 'src/app/models/screeningInvite';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-group-income',
  templateUrl: './group-income.component.html',
  styleUrls: ['./group-income.component.less']
})
export class GroupIncomeComponent implements AfterViewInit, OnInit {
  @Input() groupedScreenings: Screening[];
  @Input() screeningId : number;
  @Output() noteAdded: EventEmitter<ScreeningNote> = new EventEmitter();

  @ViewChild('acc', { static: false }) acc : NgbAccordion;

  savingNote: Boolean = false;
  
  public get activeScreening() : Screening {
    if(this.groupedScreenings.length > 0) {
      return this.groupedScreenings.find(s => { return s.id === this.screeningId });
    }
  }

  constructor(public router: Router, public screening: ScreeningService, public toast: ToastrService, public auth: AuthService) {
    
  }

  public get isAmc(): Boolean {
    return this.activeScreening?.invitation.clientId === 23;
  }

  ngOnInit(): void {
    console.log('screenings', this.groupedScreenings);
    //this.acc.expandAll();
  }
  ngAfterViewInit(): void {
    this.acc.expandAll();
  }

  saveNote(scr: Screening, override: boolean = false) {
    if(this.savingNote && !override) return;
    let newNote: ScreeningNote;
    newNote = new ScreeningNote;
    newNote.displayed = true;
    newNote.noteCategory = 0;
    newNote.userId = this.auth.loggedInUser.id;
    newNote.screeningId = scr.id;
    newNote.userName = this.auth.loggedInUser.userName;
    newNote.timestamp = new Date();
    newNote.note = scr._screeningNoteText;
    this.savingNote = true;
    this.screening.SaveNewScreeningNote(newNote).subscribe((res : number) => {
      if(res > 0) {
        this.noteAdded.emit(newNote);
        this.toast.success('Successfully saved note!');
        scr._screeningNoteText = undefined;
      } else {
        this.toast.error('Failed to save screening note!', '', { closeButton: true, disableTimeOut: true })
      }
      this.savingNote = false;
    },
    error => {
      this.toast.error('Failed to save screening note!', '', { closeButton: true, disableTimeOut: true })
      this.savingNote = false;
    });
  }

  openScreening(scr: Screening) {
    window.open(`${environment.portal}/screenings/review/${scr.id}`);
  }

  updateIncome(scr: Screening) {
    this.screening.UpdateScreeningPIT(scr).subscribe(res => {
      if(res) this.toast.success(`Income successfully updated for ${scr.invitation.id} - ${scr.firstName} ${scr.lastName}`);
    },
    err => {this.toast.error('error updating income')},
    () => {});
  }

  saveIncomeForGroup() {
    this.groupedScreenings.forEach(g => {
      this.updateIncome(g);
    })
  }

  saveAllNotes() {
    this.groupedScreenings.forEach(g => {
      this.saveNote(g, true);
    })
  }

}
